// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__OMXm-","title":"dialog_title__TEc3Z","message":"dialog_message__J0am6"};